import { createRequest, RequestConfig } from 'app/common/api';

import { TTerminalProfile } from '../../profiles/core/profiles';
import { TTerminal, TTerminalType } from '../core/terminal';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/update_terminal',
};

type TerminalType = Pick<TTerminalType, 'id'>;
type TerminalProfile = Pick<TTerminalProfile, 'id'>;

type UpdatedTerminal = Omit<TTerminal, 'type' | 'profile'> & {
  type: TerminalType;
  profile?: TerminalProfile;
};

export const updateTerminalRequest = (body: UpdatedTerminal) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(body),
  });
